import { render, staticRenderFns } from "./SimpleFileDrop.vue?vue&type=template&id=02dcbef6&scoped=true&"
import script from "./SimpleFileDrop.vue?vue&type=script&lang=js&"
export * from "./SimpleFileDrop.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFileDrop.vue?vue&type=style&index=0&id=02dcbef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dcbef6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
